import {ShippingApiService} from "./ShippingApiService";
import {ShippingErrorHandler} from "./ShippingErrorHandler";
import {ShippingConfirmations} from "./ShippingConfirmations";

declare var autoShippedWhenOpeningSO: boolean;
declare var autoShipMultiSOItems: boolean;
declare var displayItemImages: boolean;
declare var itemDetailsPathBase: string;
declare var clientCode: string;
declare var storeCode: string;
declare var isViewOnly: boolean;

export class ShippingModals {
    static showDetails(data: any, onShopify: () => void): void {
        if (!data || !data.asset) {
            return;
        }

        const asset = data.asset;
        const modal = $("#show-details-modal");
        const detailsContent = modal.find(".details-content");

        const serialNumberText = asset.serial_number || asset.epc || 'N/A';
        const epc = asset.epc || '';
        let serialNumberHtml = serialNumberText;
        
        if (epc && typeof itemDetailsPathBase !== 'undefined') {
            const itemDetailsUrl = `${itemDetailsPathBase}/${encodeURIComponent(epc)}`;
            serialNumberHtml = `<a href="${itemDetailsUrl}" target="_blank">${serialNumberText}</a>`;
        }
        
        modal.find("h2.text-center").html(
            `<span class="text-muted">Serial Number:</span> ${serialNumberHtml}`
        );

        if (detailsContent.length) {
            detailsContent.html(`
                <div class="detail-row">
                    <span class="text-muted box-title">Type:</span> <span class="detail-value">${asset.type || 'N/A'}</span>
                </div>
                <div class="detail-row">
                    <span class="text-muted box-title">REF#:</span> <span class="detail-value">${asset.ref_number || '-'}</span>
                </div>
                <div class="detail-row">
                    <span class="text-muted box-title">Item#:</span> <span class="detail-value">${asset.item_number || 'N/A'}</span>
                </div>
                <div class="detail-row">
                    <span class="text-muted box-title">Item Details:</span> <span class="detail-value">${asset.item_details || 'N/A'}</span>
                </div>
                <div class="detail-row">
                    <span class="text-muted box-title">Source:</span> <span class="detail-value">${asset.source || 'N/A'}</span>
                </div>
                <div class="detail-row">
                    <span class="text-muted box-title">Picked Into:</span> <span class="detail-value">${asset.picked_into || 'N/A'}</span>
                </div>
                <div class="detail-row">
                    <span class="text-muted box-title">Picked By:</span> <span class="detail-value">${asset.picked_by || 'N/A'}</span>
                </div>
                <div class="detail-row">
                    <span class="text-muted box-title">Picked At:</span> <span class="detail-value">${asset.picked_at || 'N/A'}</span>
                </div>
                <div class="detail-row">
                    <span class="text-muted box-title">EPC:</span> <span class="detail-value">${asset.epc || 'N/A'}</span>
                </div>
            `);
        }

        // Handle image display if enabled
        const imageElement = modal.find("#details-modal-image");
        if (imageElement.length && typeof displayItemImages !== 'undefined' && displayItemImages) {
            const thumbUrl = asset.item_image_url || '';
            const originalUrl = asset.item_image_original_url || thumbUrl;
            const placeholderImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
            const hasRealImage = originalUrl && originalUrl !== placeholderImage;

            // Add error handler to hide image if it fails to load
            imageElement.off('error').on('error', function() {
                $(this).hide();
                $(this).attr('src', '');
                $(this).attr('alt', '');
                $(this).removeAttr('title');
            });
            
            if (hasRealImage) {
                imageElement.attr('src', thumbUrl);
                imageElement.attr('alt', asset.item_details || asset.item_number || 'Item Image');
                imageElement.addClass('modal-image-trigger');
                imageElement.css('cursor', 'pointer');
                imageElement.attr('title', 'Click to view full size');
                imageElement.attr('data-original', originalUrl);
                imageElement.attr('data-alt', asset.item_details || asset.item_number || 'Item Image');
                imageElement.show();
            } else {
                imageElement.hide();
            }
        } else if (imageElement.length) {
            imageElement.hide();
        }

        const shopifyButton = modal.find("button").filter((i, el) => {
            return $(el).text().trim().includes("Open in Shopify");
        });
        
        if (data.retail_order_number && shopifyButton.length && data.shopify_url) {
            shopifyButton.off("click").on("click", (e: JQuery.ClickEvent) => {
                e.preventDefault();
                modal.modal("hide");
                onShopify();
            });
            shopifyButton.prop("disabled", false);
        } else {
            shopifyButton.prop("disabled", true);
        }

        modal.modal("show");
    }

    static showSoMulti(data: any, onShopify: () => void, onReloadAsset?: (assetId?: string | number, epc?: string) => void): void {
        if (!data || !data.asset || !data.wave_order) {
            return;
        }

        const waveOrder = data.wave_order;
        const summary = data.summary || {};
        const missingItems = data.missing_items || [];
        const waveOrderAssets = data.wave_order_assets || [];
        const modal = $("#show-so-multi-details-modal");

        // Set SO number with link to sales order details
        const soNumber = waveOrder.reference_number || data.asset.ref_number || 'N/A';
        const soNumberElement = $("#so-multi-so-number");
        
        if (data.sales_order && data.sales_order.id && typeof clientCode !== 'undefined' && typeof storeCode !== 'undefined') {
            const salesOrderUrl = `/${clientCode}/${storeCode}/sales_orders/transactions/${data.sales_order.id}`;
            soNumberElement.html(`<a href="${salesOrderUrl}" target="_blank">${soNumber}</a>`);
        } else {
            soNumberElement.text(soNumber);
        }

        // Set Source and Picked Into
        const firstAsset = waveOrderAssets.length > 0 ? waveOrderAssets[0] : data.asset;
        $("#so-multi-source").text(firstAsset.source || '-');
        $("#so-multi-picked-into").text(firstAsset.picked_into || '-');

        // Set summary stats
        $("#so-multi-expected").text(`${summary.expected_skus || 0} / ${summary.expected_assets || 0}`);
        $("#so-multi-waved").text(`${summary.waved_skus || 0} / ${summary.waved_assets || 0}`);
        $("#so-multi-picked").text(`${summary.picked_skus || 0} / ${summary.picked_assets || 0}`);
        $("#so-multi-missed").text(`${summary.missed_skus || 0} / ${summary.missed_assets || 0}`);
        $("#so-multi-shipped").text(`${summary.shipped_skus || 0} / ${summary.shipped_assets || 0}`);

        // Set auto-ship status (disabled in view only mode)
        const autoShipEnabled = !isViewOnly && autoShippedWhenOpeningSO;
        const autoShipAllEnabled = !isViewOnly && (typeof autoShipMultiSOItems !== 'undefined' ? autoShipMultiSOItems : false);
        
        $("#so-multi-auto-ship-status")
            .removeClass('text-success text-danger')
            .addClass(autoShipEnabled ? 'text-success' : 'text-danger')
            .text(autoShipEnabled ? 'enabled' : 'disabled');
        
        $("#so-multi-auto-ship-all-status")
            .removeClass('text-success text-danger')
            .addClass(autoShipAllEnabled ? 'text-success' : 'text-danger')
            .text(autoShipAllEnabled ? 'enabled' : 'disabled');

        // Populate assets table
        const assetsTbody = $("#so-multi-assets-tbody");
        assetsTbody.empty();

        // Find the entered asset to highlight it
        const enteredAsset = data.asset;
        const enteredEpc = enteredAsset.epc || '';
        const enteredSerial = enteredAsset.serial_number || '';
        
        // Sort assets to put entered asset at the top
        const sortedAssets = [...waveOrderAssets].sort((a: any, b: any) => {
            const aIsEntered = (enteredEpc && (a.epc === enteredEpc || a.serial_number === enteredEpc)) ||
                              (enteredSerial && (a.serial_number === enteredSerial || a.epc === enteredSerial));
            const bIsEntered = (enteredEpc && (b.epc === enteredEpc || b.serial_number === enteredEpc)) ||
                              (enteredSerial && (b.serial_number === enteredSerial || b.epc === enteredSerial));
            
            // Entered asset comes first
            if (aIsEntered && !bIsEntered) return -1;
            if (!aIsEntered && bIsEntered) return 1;
            return 0; // Keep original order for non-entered assets
        });
        
        // Determine if we should check all checkboxes (auto-ship all items enabled)
        const shouldCheckAll = autoShipAllEnabled;
        
        // Count shipped assets
        let shippedCount = 0;

        const columnCount = typeof displayItemImages !== 'undefined' && displayItemImages ? 6 : 5;
        if (sortedAssets.length === 0) {
            assetsTbody.append(`<tr><td colspan='${columnCount}' class='text-center text-muted'>No assets found</td></tr>`);
        } else {
            sortedAssets.forEach((asset: any, index: number) => {
                // Check if this is the entered asset (match by EPC or serial number)
                const isEnteredAsset = (enteredEpc && (asset.epc === enteredEpc || asset.serial_number === enteredEpc)) ||
                                      (enteredSerial && (asset.serial_number === enteredSerial || asset.epc === enteredSerial));
                
                // Determine if checkbox should be checked (only if not shipped)
                const shouldCheck = !asset.shipped && (shouldCheckAll || isEnteredAsset);
                
                // Count shipped assets
                if (asset.shipped) {
                    shippedCount++;
                }
                
                const row = $("<tr>")
                    .addClass("center-content")
                    .css("background-color", isEnteredAsset ? "#faf6e3" : "")
                    .addClass(isEnteredAsset ? "bold" : "");

                // Checkbox - disable if shipped
                const checkboxCell = $("<td>");
                const checkbox = $("<div>").addClass("checkbox").css("display", "inline-block");
                const label = $("<label>").css({ "min-width": "unset !important" });
                const checkboxInput = $("<input>")
                    .attr("type", "checkbox")
                    .addClass("so-multi-record")
                    .prop("checked", shouldCheck)
                    .prop("disabled", asset.shipped)
                    .attr("data-asset-id", asset.id || "")
                    .attr("data-epc", asset.epc || "")
                    .attr("data-shopify-url", asset.shopify_url || "");
                const crSpan = $("<span>").addClass("cr");
                crSpan.append($("<i>").addClass("cr-icon fa fa-check"));
                label.append(checkboxInput).append(crSpan);
                checkbox.append(label);
                checkboxCell.append(checkbox);
                row.append(checkboxCell);

                // Shipped status
                row.append($("<td>").html(
                    asset.shipped 
                        ? '<i class="fa fa-check text-success"></i>' 
                        : '<i class="fa fa-close text-danger"></i>'
                ));

                // Item Details
                const itemDetailsCell = $("<td>")
                    .attr("style", "text-align: left !important; line-height: 14px;");
                
                let itemNumberHtml = `<span class="text-muted">${asset.item_number || ''}</span>`;
                if (asset.item_number && typeof clientCode !== 'undefined' && typeof storeCode !== 'undefined') {
                    const itemGroupUrl = `/${clientCode}/${storeCode}/item_group/${encodeURIComponent(asset.item_number)}`;
                    itemNumberHtml = `<a href="${itemGroupUrl}" target="_blank" class="text-muted">${asset.item_number}</a>`;
                }
                itemDetailsCell.html(`${itemNumberHtml}<br/>${asset.item_details || ''}`);
                row.append(itemDetailsCell);

                // Serial Number
                const serialNumberText = asset.serial_number || asset.epc || '';
                let serialNumberHtml = serialNumberText;
                if (asset.epc && typeof itemDetailsPathBase !== 'undefined') {
                    const itemDetailsUrl = `${itemDetailsPathBase}/${encodeURIComponent(asset.epc)}`;
                    serialNumberHtml = `<a href="${itemDetailsUrl}" target="_blank">${serialNumberText}</a>`;
                }
                row.append($("<td>").html(serialNumberHtml));

                // Picked At / By
                row.append($("<td>")
                    .css("line-height", "14px")
                    .html(`${asset.picked_at || ''}<br/>${asset.picked_by || ''}`)
                );

                // Picture column (if enabled)
                if (typeof displayItemImages !== 'undefined' && displayItemImages) {
                    const pictureCell = $("<td>")
                        .addClass("heighter image-cell")
                        .css({
                            "padding": "8px",
                            "vertical-align": "middle",
                            "text-align": "center"
                        });
                    const thumbUrl = asset.item_image_url || '';
                    const originalUrl = asset.item_image_original_url || thumbUrl;
                    const placeholderImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
                    const hasRealImage = originalUrl && originalUrl !== placeholderImage;
                    
                    if (hasRealImage) {
                        const img = $("<img>")
                            .attr("src", thumbUrl)
                            .attr("alt", asset.item_details || asset.item_number || 'Item Image')
                            .css({
                                "max-width": "50px",
                                "max-height": "50px",
                                "width": "auto",
                                "height": "auto",
                                "object-fit": "contain",
                                "border-radius": "5px",
                                "display": "block",
                                "margin": "0 auto"
                            })
                            .addClass("modal-image-trigger")
                            .css("cursor", "pointer")
                            .attr("title", "Click to view full size")
                            .attr("data-original", originalUrl)
                            .attr("data-alt", asset.item_details || asset.item_number || 'Item Image')
                            .on("error", function() {
                                $(this).hide();
                                $(this).attr("src", "");
                                $(this).attr("alt", "");
                                $(this).removeAttr("title");
                                $(this).removeAttr("data-original");
                                $(this).removeAttr("data-alt");
                            });
                        pictureCell.append(img);
                    }
                    row.append(pictureCell);
                }

                assetsTbody.append(row);
            });
        }

        // Populate missing items table
        const missingItemsTbody = $("#so-multi-missing-items-tbody");
        const missingItemsSection = $("#so-multi-missing-items-section");
        
        if (missingItems.length > 0) {
            missingItemsSection.show();
            missingItemsTbody.empty();
            
            missingItems.forEach((item: any) => {
                const row = $("<tr>").addClass("center-content");
                
                // Item# with link
                const itemNumberCell = $("<td>");
                if (item.item_number && typeof clientCode !== 'undefined' && typeof storeCode !== 'undefined') {
                    const itemGroupUrl = `/${clientCode}/${storeCode}/item_group/${encodeURIComponent(item.item_number)}`;
                    itemNumberCell.html(`<a href="${itemGroupUrl}" target="_blank">${item.item_number}</a>`);
                } else {
                    itemNumberCell.text(item.item_number || '');
                }
                row.append(itemNumberCell);
                
                row.append($("<td>").text(item.upc || '-'));
                row.append($("<td>").attr("style", "text-align: left !important").text(item.item_details || ''));
                row.append($("<td>").text(item.expected || 0));
                row.append($("<td>").attr("style", "text-align: left !important").text(item.reason || ''));
                missingItemsTbody.append(row);
            });
        } else {
            missingItemsSection.hide();
        }

        // Check if all assets are shipped
        const allAssetsShipped = shippedCount === sortedAssets.length && sortedAssets.length > 0;
        
        // Set initial state of select all checkbox (only check enabled checkboxes)
        const enabledCheckboxes = $(".so-multi-record:enabled");
        const checkedEnabled = enabledCheckboxes.filter(":checked").length;
        const totalEnabled = enabledCheckboxes.length;
        $("#so-multi-select-all").prop("checked", totalEnabled > 0 && checkedEnabled === totalEnabled);
        $("#so-multi-select-all").prop("disabled", allAssetsShipped || totalEnabled === 0);
        
        // Bind select all checkbox (only affects enabled checkboxes)
        $("#so-multi-select-all").off("click").on("click", () => {
            if ($("#so-multi-select-all").prop("disabled")) {
                return;
            }
            const checkAll = $("#so-multi-select-all").is(":checked");
            $(".so-multi-record:enabled").prop("checked", checkAll);
        });

        // Bind individual record checkboxes
        $(document).off("click", ".so-multi-record").on("click", ".so-multi-record", function() {
            if ($(this).prop("disabled")) {
                return false;
            }
            
            const selectedCount = $(".so-multi-record:enabled:checked").length;
            const enabledCount = $(".so-multi-record:enabled").length;
            
            if (!$(this).is(":checked")) {
                $("#so-multi-select-all").prop("checked", false);
            } else if (selectedCount === enabledCount && enabledCount > 0) {
                $("#so-multi-select-all").prop("checked", true);
            }
        });

        // Bind Shopify button
        const shopifyButton = $("#so-multi-open-shopify-btn");
        const warningMessage = $("#so-multi-warning-message");
        const warningText = $("#so-multi-warning-text");
        
        // Hide warning initially
        warningMessage.hide();
        
        if (allAssetsShipped) {
            // All assets are shipped - disable button and show warning
            shopifyButton.prop("disabled", true);
            warningText.text("This order has already been shipped.");
            warningMessage.show();
        } else if (data.shopify_url) {
            // Bind click handler to process selected assets
            shopifyButton.off("click").on("click", async (e: JQuery.ClickEvent) => {
                e.preventDefault();
                
                const selectedCheckboxes = $(".so-multi-record:enabled:checked");
                
                if (selectedCheckboxes.length === 0) {
                    ShippingErrorHandler.showWarning("Please select at least one asset");
                    return;
                }
                
                // Collect selected assets
                const selectedAssets: Array<{id: string, epc: string, shopifyUrl: string, shipped: boolean}> = [];
                selectedCheckboxes.each(function() {
                    const checkbox = $(this);
                    const assetId = checkbox.attr("data-asset-id") || "";
                    const epc = checkbox.attr("data-epc") || "";
                    const shopifyUrl = checkbox.attr("data-shopify-url") || "";
                    const row = checkbox.closest("tr");
                    const isShipped = row.find("td").eq(1).find(".fa-check").length > 0; // Check shipped status icon
                    
                    if (assetId || epc) {
                        selectedAssets.push({
                            id: assetId,
                            epc: epc,
                            shopifyUrl: shopifyUrl || data.shopify_url,
                            shipped: isShipped
                        });
                    }
                });
                
                if (selectedAssets.length === 0) {
                    ShippingErrorHandler.showWarning("No valid assets selected");
                    return;
                }
                
                // Check if auto ship is enabled (disabled in view only mode)
                const autoShipEnabled = !isViewOnly && (typeof autoShippedWhenOpeningSO !== 'undefined' ? autoShippedWhenOpeningSO : false);
                
                // Helper function to show/hide spinner on button
                const showSpinner = () => {
                    shopifyButton.prop("disabled", true);
                    const originalText = shopifyButton.html();
                    shopifyButton.data("original-text", originalText);
                    shopifyButton.html('<i class="fa fa-spinner fa-spin"></i> Processing...');
                };
                
                const hideSpinner = () => {
                    shopifyButton.prop("disabled", false);
                    const originalText = shopifyButton.data("original-text") || "Open in Shopify";
                    shopifyButton.html(originalText);
                };
                
                // Helper function to open URLs
                const openShopifyUrls = () => {
                    const uniqueShopifyUrls = Array.from(new Set(selectedAssets.map(a => a.shopifyUrl).filter(url => url)));
                    
                    uniqueShopifyUrls.forEach((url) => {
                        if (url && url.trim() !== "") {
                            window.open(url, "_blank");
                        }
                    });
                    
                    modal.modal("hide");
                };
                
                // Helper function to mark assets as shipped (async operations)
                const markAssetsAsShipped = async () => {
                    const assetsToShip = selectedAssets.filter(asset => !asset.shipped);
                    
                    for (const asset of assetsToShip) {
                        try {
                            if (!asset.id) {
                                ShippingErrorHandler.showWarning("Cannot mark asset as shipped - asset ID is required");
                                continue;
                            }
                            
                            const assetId = parseInt(asset.id, 10);
                            await ShippingApiService.markShipped(assetId);
                            // Reload asset in table if callback provided
                            if (onReloadAsset) {
                                await onReloadAsset(assetId, asset.epc);
                            }
                        } catch (error) {
                            ShippingErrorHandler.logError("marking asset as shipped", error);
                        }
                    }
                };
                
                // If auto ship is enabled, show confirmation before shipping
                if (autoShipEnabled) {
                    await ShippingConfirmations.confirmShopifyAndShip(
                        async () => {
                            // CRITICAL: Open URLs FIRST, synchronously, right after user confirms
                            // This keeps us in the user action context
                            openShopifyUrls();
                            
                            // Then show spinner and do async shipping operations
                            showSpinner();
                            await markAssetsAsShipped();
                            hideSpinner();
                        },
                        () => {
                            // User cancelled - do nothing
                        }
                    );
                } else {
                    // Auto ship is NOT enabled - only open Shopify URLs (don't ship)
                    openShopifyUrls();
                }
            });
            shopifyButton.prop("disabled", false);
        } else {
            shopifyButton.prop("disabled", true);
            warningText.text("No Shopify order found");
            warningMessage.show();
        }

        modal.modal("show");
    }

    static showAlreadyShipped(asset: any): void {
        if (!asset) {
            return;
        }

        const modal = $("#already-shipped-modal");
        const serialNumberText = asset.serial_number || asset.epc || 'N/A';
        const epc = asset.epc || '';
        let serialNumberHtml = serialNumberText;
        
        if (epc && typeof itemDetailsPathBase !== 'undefined') {
            const itemDetailsUrl = `${itemDetailsPathBase}/${encodeURIComponent(epc)}`;
            serialNumberHtml = `<a href="${itemDetailsUrl}" target="_blank">${serialNumberText}</a>`;
        }
        
        modal.find("h2.text-center").html(
            `<span class="text-muted">Serial Number:</span> ${serialNumberHtml}`
        );

        $("#already-shipped-serial").text(serialNumberText);
        $("#already-shipped-type").text(asset.type || 'N/A');
        $("#already-shipped-ref").text(asset.ref_number || '-');
        $("#already-shipped-item").text(asset.item_number || 'N/A');
        $("#already-shipped-item-details").text(asset.item_details || 'N/A');
        $("#already-shipped-source").text(asset.source || 'N/A');
        $("#already-shipped-picked-into").text(asset.picked_into || 'N/A');
        $("#already-shipped-picked-by").text(asset.picked_by || 'N/A');
        $("#already-shipped-picked-at").text(asset.picked_at || 'N/A');
        $("#already-shipped-epc").text(asset.epc || 'N/A');

        // Handle image display if enabled
        const imageElement = modal.find("#already-shipped-modal-image");
        if (imageElement.length && typeof displayItemImages !== 'undefined' && displayItemImages) {
            const thumbUrl = asset.item_image_url || '';
            const originalUrl = asset.item_image_original_url || thumbUrl;
            const placeholderImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
            const hasRealImage = originalUrl && originalUrl !== placeholderImage;

            // Add error handler to hide image if it fails to load
            imageElement.off('error').on('error', function() {
                $(this).hide();
                $(this).attr('src', '');
                $(this).attr('alt', '');
            });
            
            if (hasRealImage) {
                imageElement.attr('src', thumbUrl);
                imageElement.attr('alt', asset.item_details || asset.item_number || 'Item Image');
                imageElement.show();
            } else {
                imageElement.hide();
            }
        } else if (imageElement.length) {
            imageElement.hide();
        }

        modal.modal("show");
    }
}
